// 이 파일은 scripts/prebuild.js 가 package.json 의 version 으로 만든다 — 직접 고치지 않는다.
export const APP_VERSION = "0.47.0";
